"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizationFragmentDependencies = exports.authorizationFragment = void 0;
exports.authorizationFragment = `
fragment authorizationFragment on Authorization {
  token
  expiry
}
`.trim();
exports.authorizationFragmentDependencies = [];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aG9yaXphdGlvbkZyYWdtZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL2ZyYWdtZW50cy9hdXRob3JpemF0aW9uRnJhZ21lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxxQkFBcUIsR0FBRzs7Ozs7Q0FLcEMsQ0FBQyxJQUFJLEVBQUUsQ0FBQztBQUVJLFFBQUEsaUNBQWlDLEdBQUcsRUFBRSxDQUFDIn0=